import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';

export default function BillingSuccess() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const [txId, setTxId] = useState('');

    useEffect(() => { setTxId(params.get('tx') || ''); }, [params]);

    return (
        <div className="min-h-[calc(100vh-73px)] grid place-items-center p-8">
            <div className="max-w-md text-center" data-testid="billing-success-root">
                <CheckCircle2 className="h-12 w-12 mx-auto text-[#FF6B35]" />
                <h1 className="mt-6 font-heading text-3xl">You&apos;re all set.</h1>
                <p className="mt-2 text-muted-foreground">Your plan is now active. Head back to your dashboard to start uploading.</p>
                {txId && <p className="mt-2 text-xs text-muted-foreground font-mono">tx: {txId}</p>}
                <Button data-testid="back-to-dashboard-btn" onClick={() => nav('/dashboard')} className="mt-6 bg-[#FF6B35] hover:bg-[#E55C2A] text-white">Go to dashboard</Button>
            </div>
        </div>
    );
}
